import { createSlice } from '@reduxjs/toolkit';

import * as OnboardingService from 'Services/Apis/Onboarding';

import { hasEncryptedSSO } from 'Constants/Auth';
import { onboardingUrl } from 'Constants/Onboarding';

const initialState = {
  onboardingRedirectUrl: null,
};

const OnboardingSlice = createSlice({
  name: 'OnboardingSlice',
  initialState,
  reducers: {
    setOnboardingRedirectUrl: (state, action) => {
      state.onboardingRedirectUrl = action.payload;
    },
  },
});

export const buildOnboardingRedirectUrl = () => async (dispatch, getState) => {
  try {
    const {
      oidc: { user },
    } = getState();

    let redirectUrl = null;

    if (!hasEncryptedSSO) {
      redirectUrl = `${onboardingUrl}${user.profile['custom:campaign_id']}`;
    } else {
      const { data: encryption } = await OnboardingService.encrypt(user);
      redirectUrl = `${onboardingUrl}?sso=${encryption}`;
    }

    dispatch(setOnboardingRedirectUrl(redirectUrl));
  } catch (err) {
    console.log('Não foi possível obter a URL de redirecionamento.');
  }
};

export const { setOnboardingRedirectUrl } = OnboardingSlice.actions;

export default OnboardingSlice.reducer;
